import { createIcon } from "@chakra-ui/icons";

// Created from info-icon.svg

export const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <circle
        cx="12"
        cy="12"
        r="11.25"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="7.2"
        r="0.75"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.9"
      />
      <path
        d="M12 18L12 11.3271"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
});
